"use client";

import { useEffect, useRef, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactHero() {
  const {
    ref: heroRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [scrollY, setScrollY] = useState(0);
  const [overlayHovered, setOverlayHovered] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const parallaxOffset = scrollY * 0.3;
  const overlayOpacity = Math.min(scrollY / 300, 1);
  return <section ref={heroRef} className="relative h-screen w-full overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 ease-out" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1454827/img/contact_hero_background.png)",
      transform: `translateY(${parallaxOffset}px)`
    }}>
        {}
        <div className="absolute inset-0 bg-dark-background/40" />
      </div>

      {}
      <div className="relative z-10 flex h-full items-center justify-center px-6">
        {}
        <div className={`
            max-w-3xl rounded-lg border border-border-strong/20 
            bg-light-background/70 backdrop-blur-md px-12 py-16 text-center 
            shadow-strong transition-all duration-500 ease-out
            ${overlayHovered ? "backdrop-blur-sm" : ""}
          `} style={{
        opacity: overlayOpacity
      }} onMouseEnter={() => setOverlayHovered(true)} onMouseLeave={() => setOverlayHovered(false)}>
          {}
          <h1 className={`
              mb-6 font-display text-5xl font-bold leading-tight text-foreground-light 
              transition-opacity duration-700 md:text-6xl
              ${isVisible ? "opacity-100" : "opacity-0"}
            `}>
            Get in Touch with Haven Holdings Capital
          </h1>

          {}
          <p className={`
              text-lg leading-relaxed text-foreground-light/80 transition-opacity 
              duration-700 delay-150 md:text-xl
              ${isVisible ? "opacity-100" : "opacity-0"}
            `}>
            Connect with our team to discuss investment opportunities in
            purpose-built properties for highly regulated industries. We're here
            to answer your questions and explore how our disciplined approach
            can deliver risk-adjusted returns.
          </p>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-border-strong transition-opacity duration-500" style={{
      opacity: scrollY > 100 ? 1 : 0
    }} />
    </section>;
}